import { useGroupStore } from '@base-shared/stores/group';

export const BANNER_TYPES = {
  UNSUPPORTED_BROWSER: 'unsupportedBrowser',
  ARYA_SUSPENDED: 'accountSuspended'
}

export default {
  name: 'alertBanner',
  inject: [
    '$utils',
    '$signedInUserInfo'
  ],
  data () {
    return {
      isBannerClosed: false,
      isActivePlanSuspended: false,
      bannersState: {
        [BANNER_TYPES.UNSUPPORTED_BROWSER]: {
          type: 'info',
          title: this.$t('unsupportedBrowser.bannerTitle'),
          message: this.$t(
            'unsupportedBrowser.bannerMessage',
            {
              highlightStart: '<span class="text-jet">',
              highlightEnd: '</span>'
            }
          ),
          hideCloseBtn: false,
          wasBannerClosed: false
        },
        [BANNER_TYPES.ARYA_SUSPENDED]: {
          type: 'error',
          title: this.$t('accountSuspended.bannerTitle'),
          message: this.$t('accountSuspended.bannerMessage'),
          hideCloseBtn: true
        }
      }
    }
  },
  computed: {
    isUnsupportedBrowserEnabled () {
      const browser = this.$utils.getBrowser()
      if (['Chrome', 'Edge'].includes(browser)) {
        return false
      }

      return ['home', 'menuComp', 'activation'].includes(this.$route.name)
    },
    isAccountSuspendendEnabled () {
      return this.$route.name === 'settings' && this.isActivePlanSuspended
    },
    selectedBannerType () {
      if (this.isUnsupportedBrowserEnabled) {
        return BANNER_TYPES.UNSUPPORTED_BROWSER
      } else if (this.isAccountSuspendendEnabled) {
        return BANNER_TYPES.ARYA_SUSPENDED
      }

      return null
    },
    shouldHideCloseBtn () {
      if (!this.selectedBannerType) {
        return false
      }

      return !!this.bannersState[this.selectedBannerType]?.hideCloseBtn
    },
    isBannerEnabled () {
      if (!this.selectedBannerType) {
        return false
      }

      // Account suspension should have no effect on Activate
      if (this.$utils.isPageForLicenses() && this.selectedBannerType === BANNER_TYPES.ARYA_SUSPENDED) {
        return false
      }

      // Hide banner that has close btn and already taged as closed
      if (
        !this.bannersState[this.selectedBannerType].hideCloseBtn &&
        !!this.bannersState[this.selectedBannerType].wasBannerClosed
      ) {
        return false
      }

      return true
    }
  },
  watch: {
    /**
     * Watches the `groupStore.groupInfo` for changes. Replacement
     * for the old `BIND_USER_INFO_IN_VUE` from EventBus.
     */
    'groupStore.groupInfo': {
      handler (newValue) {
        // Handle suspended active plan from group info
        this.isActivePlanSuspended = !!this.groupStore.groupInfo?.activePlan?.suspended
      },
      deep: true,
      immediate: true
    }
  },
  setup () {
    // Expose the store to the Options API context.
    return { groupStore: useGroupStore() };
  },
  methods: {
    onBannerClosed () {
      if (
        this.bannersState[this.selectedBannerType] &&
        !this.bannersState[this.selectedBannerType].hideCloseBtn
      ) {
        this.bannersState[this.selectedBannerType].wasBannerClosed = true
      }
    }
  }
}
